import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

const RenderTime = ({ remainingTime }) => {
  const { t } = useTranslation('common');
  if (remainingTime === 0) {
    return <div className={styles.timer}>{t('expire')}</div>;
  }
  return (
    <div className={styles.timer}>
      <div className={styles.value}>{remainingTime}</div>
    </div>
  );
};

const CircleTimer = ({ duration }) => (
  <CountdownCircleTimer
    isPlaying
    duration={duration}
    size={80}
    strokeWidth={8}
    colors={[
      ['#005C29', 0.4],
      ['#3cb56b', 0.35],
      ['#9ac100', 0.25],
    ]}
  >
    {RenderTime}
  </CountdownCircleTimer>
);
export default CircleTimer;
